import styled from "styled-components";
import theme from "../styles/theme";
import Status from "../types/enum/Status";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import { RightAlign } from "./UtilsComponents";

type CourseDropModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  title: string;
  description: string;
};
const Title = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 0px 24px;
  width: 318px;
  background: rgba(236, 197, 198, 0.1);
  border-radius: 4px;
  margin: 24px 0px;
`;
const Desc = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  padding: 16px 0;
  display: flex;
  align-items: center;
  // text-align: center;
  margin: 0px 10px;
  white-space: pre-wrap;
  word-break: break-word;
`;

const ConfirmModal = ({
  isOpen,
  setOpen,
  confirmFunction,
  title,
  description,
}: CourseDropModalProps): JSX.Element => {
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: { maxWidth: "600px", padding: "0 16px 24px 16px" },
        }}
      >
        <FlexBox style={{ height: "64px", borderBottom: "1px solid #dbdbdb" }}>
          <FlexGrow>
            <Title>{title}</Title>
          </FlexGrow>
          <ClickableIcon
            name="close"
            color="white"
            onClick={() => setOpen(false)}
          />
        </FlexBox>
        <FlexBox>
          <Flex style={{ border: '1px solid #fbbf24', color: "#000000", background:"#fef3c7", fontWeight: "" }}>
            <Desc>{description}</Desc>
          </Flex>
        </FlexBox>
        <FlexBox justify="center">
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              className="reduce_opct_onhover"
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
                border: "2px solid rgb(203, 213, 225)",
                // color: "gray"
                // backgroundColor: '#c75151'
              }}
              isOutline
              onClick={() => {
                setOpen(false);
              }}
            >
              No
            </Button>
          </FlexGrow>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              className="reduce_opct_onhover"
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
                color: "white",
                background: theme.color.blueButton,
                boxShadow: "0 2px 5px gray",
                border: "none",
              }}
              type="button"
              onClick={() => {
                confirmFunction();
              }}
            >
              Yes
            </Button>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default ConfirmModal;
